'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseAxisController=require('../../../../dist-es6/client/directives/plotting/baseAxisController');
const BaseAxisDirective=require('../../../../dist-es6/client/directives/plotting/baseAxisDirective');let

ShiftedLinearAxisController=function(_BaseAxisController){_inherits(ShiftedLinearAxisController,_BaseAxisController);
function ShiftedLinearAxisController($scope){_classCallCheck(this,ShiftedLinearAxisController);return _possibleConstructorReturn(this,
_BaseAxisController.call(this,$scope));
}_createClass(ShiftedLinearAxisController,[{key:'_scaleCreator',get:function()

{
return d3.scale.linear();
}},{key:'lengthOnScreen',set:function(

newLength){
if(newLength===this._lengthOnScreen){
return;
}
this._lengthOnScreen=newLength;

switch(this.orientation){
case'horizontal':
this._range={start:this.plotArea.graphAreaBoundaries.left+this.offset,end:this.plotArea.dimensions.width};
break;
case'vertical':
this._range={start:this.plotArea.dimensions.height,end:this.plotArea.graphAreaBoundaries.top+this.offset};
break;}


this._updateScale();
}}]);return ShiftedLinearAxisController}(BaseAxisController);let


ShiftedLinearAxisDirective=function(_BaseAxisDirective){_inherits(ShiftedLinearAxisDirective,_BaseAxisDirective);function ShiftedLinearAxisDirective(){_classCallCheck(this,ShiftedLinearAxisDirective);return _possibleConstructorReturn(this,_BaseAxisDirective.apply(this,arguments))}_createClass(ShiftedLinearAxisDirective,[{key:'controller',get:function()
{return ShiftedLinearAxisController}}]);return ShiftedLinearAxisDirective}(BaseAxisDirective);


module.exports=ShiftedLinearAxisDirective;
//# sourceMappingURL=shiftedLinearAxisDirective.js.map
